exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-w[data-v-7805a54e]{width:100%}.list[data-v-7805a54e]{padding:0 .2rem}.item[data-v-7805a54e]{height:.88rem;border-color:#e5e5e5}.tit[data-v-7805a54e]{margin-right:.44rem;width:1.36rem}.flex-item[data-v-7805a54e],.flex-item input[data-v-7805a54e]{height:100%}.tBanner img[data-v-7805a54e]{width:100%;height:1.5rem}.sign[data-v-7805a54e]:after{content:\"*\";color:red}.recom-bottom[data-v-7805a54e]{background:#f7f7f7;padding-top:.2rem}.remark[data-v-7805a54e]{padding:.27rem .2rem}.remark textarea[data-v-7805a54e]{height:.8rem;border:0;resize:none}.btn[data-v-7805a54e]{color:#fff;background:#d8d8d8;height:.9rem;line-height:.9rem;margin:.4rem .2rem;border-radius:.04rem;margin-top:2rem}.active[data-v-7805a54e]{background:#0047ba}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7805a54e","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/recommend/recommend.vue
// module id = 263
// module chunks = 0